import { LegacyMasonry } from '@leagueplatform/masonry';
import {
  SCREEN_NAMES,
  SUB_PRODUCT_AREA,
  usePageViewAnalytics,
} from '@leagueplatform/analytics';
import React from 'react';
import { useDocumentTitle } from '@leagueplatform/web-common';
import { useIntl } from '@leagueplatform/locales';
import {
  ABOUT_ME_MASONRY_API_VERSION,
  HEALTH_REPORT_APP_ID,
} from '#constants/masonry.ts';
import {
  BackButtonArrow,
  MainPageContainer,
} from '@leagueplatform/web-common-components';
import {
  HeadingText,
  StackItem,
  StackLayout,
} from '@leagueplatform/genesis-core';
import {
  LinkLegacy as Link,
  useNavigateLegacy as useNavigate,
} from '@leagueplatform/routing';
import { PRODUCT_AREA } from '#constants/analytics.ts';
import { useAboutMeConfig } from '../../about-me.config';

export const HealthReportPage = () => {
  const { formatMessage } = useIntl();
  const navigate = useNavigate();

  useDocumentTitle(formatMessage({ id: 'ABOUT_ME' }));
  usePageViewAnalytics({
    screen_name: SCREEN_NAMES.HEALTH_REPORT_PAGE,
    product_area: PRODUCT_AREA.ABOUT_ME,
    sub_product_area: SUB_PRODUCT_AREA.ABOUT_ME,
  });
  useDocumentTitle(formatMessage({ id: 'HEALTH_REPORT_PAGE_HEADING' }));

  const { healthReportMasonryId = HEALTH_REPORT_APP_ID } = useAboutMeConfig();

  const HealthReportMasonry = new LegacyMasonry({
    appId: healthReportMasonryId,
    analytics: {
      productArea: SCREEN_NAMES.HEALTH_REPORT_PAGE,
      screenName: SCREEN_NAMES.HEALTH_REPORT_PAGE,
    },
    apiVersion: ABOUT_ME_MASONRY_API_VERSION,
  });

  return (
    <MainPageContainer>
      <StackLayout
        orientation={{
          '@initial': 'vertical',
          '@laptop': 'horizontal',
          '@desktop': 'horizontal',
        }}
      >
        <StackItem css={{ alignSelf: 'start' }}>
          <BackButtonArrow
            as={Link}
            to="#"
            marginY="one"
            marginInlineEnd="one"
            onClick={(event: React.MouseEvent) => {
              event.preventDefault();
              navigate(-1);
            }}
          />
        </StackItem>
        <StackLayout
          spacing="$one"
          horizontalAlignment="center"
          css={{
            '@laptop': { paddingInlineEnd: '$three' },
            '@desktop': { paddingInlineEnd: '$three' },
          }}
        >
          <HeadingText size="xxl" level="1">
            {formatMessage({ id: 'HEALTH_REPORT_PAGE_HEADING' })}
          </HeadingText>
          <HealthReportMasonry.Provider />
        </StackLayout>
      </StackLayout>
    </MainPageContainer>
  );
};
